import { render, staticRenderFns } from "./CardOtherAssigned.vue?vue&type=template&id=c40925d4"
import script from "./CardOtherAssigned.vue?vue&type=script&lang=js"
export * from "./CardOtherAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports